var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarrot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  fill: "none",
  viewBox: "0 0 12 8"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#carrot_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M6 8 0 1.89.785 1 6 6.345 11.215 1l.785.89z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "carrot_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v8H0z"
})))));
export { SvgCarrot as ReactComponent };